module.exports = __webpack_public_path__ + "static/media/procedures.a57f4768.svg";